export default __webpack_public_path__ + "static/media/circle_two.99270fbf.svg";